module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "material-design-icon",
    attrs: {
      "id": "lock-icon",
      "role": "img",
      "aria-labelledby": "lock-icon-title"
    }
  }, [_c('svg', {
    staticClass: "material-design-icon__svg",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('title', {
    attrs: {
      "id": "lock-icon-title"
    }
  }, [_vm._v(_vm._s(_vm.iconTitle))]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12,17C13.1,17 14,16.1 14,15C14,13.89 13.1,13 12,13C10.9,13 10,13.9 10,15C10,16.1 10.9,17 12,17M18,8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V10C4,8.89 4.9,8 6,8H7V6C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6V8H18M12,3C10.34,3 9,4.34 9,6V8H15V6C15,4.34 13.66,3 12,3Z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e63d654!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-material-design-icons/lock.vue
// module id = 24
// module chunks = 1